import React from 'react';

const spacer = (props) => <div style={{ background: props.noBg? "transparent" : "white", width: "100%", height: props.height }}></div>

export default spacer;


// WEBPACK FOOTER //
// ./client/src/components/Spacer/Spacer.js